var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "whatsapp-import-status-card" } },
    [
      _c("BucketSpinner", { attrs: { "class-name": "spinner" } }),
      _vm._v(" "),
      _c("div", { staticClass: "items" }, [
        _c("div", { staticClass: "item" }, [
          _c("i", { staticClass: "material-icons text-success" }, [
            _vm._v("check_circle "),
          ]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.state.imported) +
              " " +
              _vm._s(_vm.$t("whatsapp.contactsImported")) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [
          _c("i", { staticClass: "material-icons text-danger" }, [
            _vm._v("cancel "),
          ]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.state.failed) +
              " " +
              _vm._s(_vm.$t("whatsapp.contactsFailed")) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [
          _c("i", { staticClass: "material-icons text-info spin" }, [
            _vm._v("loop "),
          ]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.state.percent) +
              "% " +
              _vm._s(_vm.$t("whatsapp.percentCompleted")) +
              "\n        "
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }